import React from 'react'
import PropTypes from 'prop-types'
import { ScrollView } from 'react-native-gesture-handler'
import TractorCard from './TractorCard'
import stylesFunction from './styles'
import { View } from 'react-native'
import { usePlatforms } from '../../../../../hooks/usePlatforms'

const TractorsForm = ({ formikParams }) => {
  const { setFieldValue, values } = formikParams
  const { isTablet } = usePlatforms()

  const styles = stylesFunction(isTablet)

  return (
    <ScrollView showsVerticalScrollIndicator={false} style={styles.container}>
      <View>
        <TractorCard
          day='monday'
          recurringTractor={values}
          onChangeValue={setFieldValue}
        />
        <TractorCard
          day='tuesday'
          recurringTractor={values}
          onChangeValue={setFieldValue}
        />
        <TractorCard
          day='wednesday'
          recurringTractor={values}
          onChangeValue={setFieldValue}
        />
        <TractorCard
          day='thursday'
          recurringTractor={values}
          onChangeValue={setFieldValue}
        />
        <TractorCard
          day='friday'
          recurringTractor={values}
          onChangeValue={setFieldValue}
        />
        <TractorCard
          day='saturday'
          recurringTractor={values}
          onChangeValue={setFieldValue}
        />
        <TractorCard
          day='sunday'
          recurringTractor={values}
          onChangeValue={setFieldValue}
        />
      </View>
    </ScrollView>
  )
}

TractorsForm.propTypes = {
  formikParams: PropTypes.object
}

TractorsForm.defaultProps = {
  recurringTactorToEdit: null
}

export default TractorsForm
